/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const ResolveIncidentBody = zod.object({});

export type ResolveIncidentBody = zod.input<typeof ResolveIncidentBody>;
export type ResolveIncidentBodyOutput = zod.output<typeof ResolveIncidentBody>;
